﻿$.fn.dxCtrlVirtualGrid = function custom_dxCtrlVirtualGrid(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlvirtualgrid dx-ctrl");
        this.createInstance(new cdxCtrlVirtualGrid(this, option));
    }
    return this;
}

window.cdxCtrlVirtualGrid = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    //option.context_grid
    //option.type_data   =   définir le type de filtre a afficher
    if (typeof option.allowFilter == 'undefined') option.allowFilter = false
    if (typeof option.allowToolbar == 'undefined') option.allowToolbar = true
    if (typeof option.allowCarto == 'undefined') option.allowCarto = false
    if (typeof option.allowClick == 'undefined') option.allowClick = true
    if (typeof option.allowCheck == 'undefined') option.allowCheck = true
    if (typeof option.showFilterRempli == 'undefined') option.showFilterRempli = true
    if (typeof option.allowModifTemplateStrCon == 'undefined') option.allowModifTemplateStrCon = true
    if (typeof option.lstLstConditionBase == 'undefined') option.lstLstConditionBase = []
    if (typeof option.noPagination == 'undefined') option.noPagination = false
    if (typeof option.allowConstruire == 'undefined') option.allowConstruire = true

    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].cartoVisible = false
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].order_search == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].order_search = "score"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == 'undefined') {
        if (typeof option.typeGrille == 'undefined') { option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = option.lstTypeGrille[0] }
        else { option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = option.typeGrille }
    }
    //if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].affichage_simplifie == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].affichage_simplifie = false
    ////if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = option.lstTypeGrille[0]

    var $DivFilter = null
    var $DivFilterRapide = null
    var $DivGrid = null
    var resizeSensorFilterFunc = null
    //var ctrlResize = null
    var jaugeGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")
        container.css("position", "relative")

        //option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_left = false
        //option.bddCtrl.utiCourantParaJson[option.context_grid].splitter_collapsed_right = true
        //ctrlResize = $("<div style='width:100%;height:100%;display:none;z-index:0;'/>").appendTo(container).dxCtrlSplitterResize2({
        //    bddCtrl: option.bddCtrl,
        //    orientation: "vertical",
        //    collapsibleLeft: false,
        //    collapsibleRight: false,
        //    context_grid: option.context_grid,
        //    withMarge: false,
        //    widthLeftInitial: container.innerWidth() / 2
        //}).dxCtrlSplitterResize2("instance")

        $DivFilterRapide = $("<div/>").appendTo(container)
        $DivGrid = $("<div style='height:100%;' class='divgrid'/>").appendTo(container)
        jaugeGrid = $("<div/>").appendTo($DivGrid).dxCtrlJauge({}).dxCtrlJauge("instance")
        if (option.allowConstruire) mConstruitGrid()
        if (typeof option.contentTemplateFilterRapide != 'undefined') {
            $DivFilterRapide.css("padding", "10px")
            option.contentTemplateFilterRapide($DivFilterRapide)
            window.setTimeout(function () { $DivGrid.css("height", "calc(100% - " + $DivFilterRapide.innerHeight() + "px)") }, 100)
        }
        mConstruitFilter()

        //ctrlResize.mConstruitLeft(function (contentElementLeft) {
        //    $DivFilterRapide = $("<div/>").appendTo(contentElementLeft)
        //    $DivGrid = $("<div style='height:100%;' class='divgrid'/>").appendTo(contentElementLeft)
        //    jaugeGrid = $("<div/>").appendTo($DivGrid).dxCtrlJauge({}).dxCtrlJauge("instance")
        //    if (option.allowConstruire) mConstruitGrid()
        //    if (typeof option.contentTemplateFilterRapide != 'undefined') {
        //        $DivFilterRapide.css("padding", "10px")
        //        option.contentTemplateFilterRapide($DivFilterRapide)
        //        window.setTimeout(function () { $DivGrid.css("height", "calc(100% - " + $DivFilterRapide.innerHeight() + "px)") }, 100)
        //    }

        //    ctrlResize.mConstruitRight(function (contentElementRight) {
        //        $DivFilter = $("<div style='position:relative;height:100%;' class='dx-theme-material-typography'></div>").appendTo(contentElementRight)
        //        if (option.allowFilter) mConstruitFilter()
        //    })
        //})

        resizeObserver.mAdd(container, function () {
            if (dxGrid != null && typeof dxGrid.mGetToolbar() != 'undefined') {
                dxGrid.mGetToolbar().repaint()
                mUpdateDxBtFilter()
            }
        })


        //ctrlResize.mHideRight()
        //window.setTimeout(function () {
        //    ctrlResize.mHideRight()
        //}, 100)

    }


    this.mUpdateDataFiltreGridBase = function (dataGridFiltreBase) {
        option.dataGridFiltreBase = dataGridFiltreBase
        option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon = option.dataGridFiltreBase
        Me.mReloadData(false)
    }

    var dxFilter = null
    var firstLoadFilter = true
    function mConstruitFilter() {
        //var $Table = $("<table style='width:100%;table-layout:fixed;height:100%;'/>").appendTo($DivFilter)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        if (option.typeData == "strcon") {
            //delete option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon
            if (option.dataGridFiltreBase) {
                //uniquement pour les lists et la création des vues
                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon = option.dataGridFiltreBase
            } else {
                if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon == 'undefined') {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon = null
                }
                if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon != null) {
                    //on vérifie avec le filtre en base
                    if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre != null) {
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.json_lst_condition == "[]") option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.json_lst_condition = "null"
                        //if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.json_lst_condition == null) {
                        //    option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.json_lst_condition = "[]"
                        //}
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.id_filtrestrcon != null) {
                            var filterEnBase = option.bddCtrl.mGetArray("filtrestrcon").filter(function (o) { return o.id_filtrestrcon == option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.id_filtrestrcon })[0]
                            if (typeof filterEnBase == 'undefined') {
                                //le filtre n'existe plus
                                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.id_filtrestrcon = null
                            } else {
                                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre = filterEnBase
                            }
                        }
                    }
                }
            }

            mUpdateDxBtFilter()

            if (option.allowConstruire) {
                window.setTimeout(function () { Me.mReloadData(true) }, 0)
            }
            //var nbCondition = ((option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrestrcon) ? JSON.parse(option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrestrcon.json_lst_condition).length : 0)
            //if (dxBtFiltre) dxBtFiltre.mRempliCompteur(nbCondition)
            //if (firstLoadFilter && nbCondition > 0 && option.showFilterRempli && showMessageFilterFirstLoading) {
            //    window.setTimeout(function () {
            //        mNotify("Vous avez un filtre sur cette grille.<br/>Cliquer sur <i class='fas fa-filter'></i> ou <a href='javascript:void(0)'>ici</a> pour visualiser le filtre.", "warning", 6000, function () {
            //            if (dxBtFiltre) dxBtFiltre.performClick()
            //        })
            //    }, 1000)
            //}

            var timeoutReloadFilter = null
            ////dxFilter = $("<div style='height:100%;'/>").appendTo($DivFilter).dxCtrlFilterBuilderStrCon({
            ////    bddCtrl: option.bddCtrl,
            ////    context_grid: option.context_grid,
            ////    type_data: option.typeData,
            ////    fields: option.fields,
            ////    dataGridVue: option.dataGridVue,
            ////    onValueChanged: function (value) {
            ////        console.log("onvaluechangedfilter");
            ////        window.clearTimeout(timeoutReloadFilter)
            ////        timeoutReloadFilter = window.setTimeout(function () { console.log("reloadfilter"); mReload() }, 200)

            ////        function mReload() {
            ////            console.log("reloadfilter Me.mReloadData(true)")
            ////            Me.mReloadData(true)
            ////            //if (dxFilter.mGetNbConditionFilter() > 0) {
            ////            //    ctrlResize.mHideRight()
            ////            //    $DivFilter.show()
            ////            //    resizeSensorFilterFunc()
            ////            //}
            ////             if (dxBtFiltre) dxBtFiltre.mRempliCompteur(dxFilter.mGetNbConditionFilter())
            ////        }

            ////    }
            ////}).dxCtrlFilterBuilderStrCon("instance")
            //$DivFilter.css({
            //    position: "absolute",
            //    width: "100%",
            //    height: "100%",
            //    top: 0,
            //    "z-index": 10,
            //    display: "none"
            //})
            //$DivFilter.appendTo(container)
            //dxFilter = $("<div style='height:100%;'/>").appendTo($DivFilter).dxCtrlFilterGridStrConPage({
            //    bddCtrl: option.bddCtrl,
            //    context_grid: option.context_grid + "_" + ((typeof option.dataGridVue == 'undefined') ? "" : "idgridvue" + option.dataGridVue.id_grid_vue),
            //    showResult: true,
            //    showSelectEle: true,
            //    dataGridVue: option.dataGridVue,
            //    onValide: function (currentDataFiltre) {
            //        //option.bddCtrl.utiCourantParaJson[option.context_grid].filter3.id_filtre = ((currentDataFiltre == null) ? null : currentDataFiltre.id_filtre)
            //        //option.bddCtrl.mSaveParaJsonUtilisateur()
            //        Me.mReloadData(true)
            //        if (dxFilter && dxBtFiltre) dxBtFiltre.mRempliCompteur(dxFilter.mGetNbConditionFilter())
            //        $DivFilter.slideUp(500)
            //    },
            //    //onClose: function () {
            //    //    $DivFilter.slideUp(500)
            //    //},
            //    onContentReady: function (component) {
            //        dxFilter = component
            //        window.setTimeout(function () {
            //            Me.mReloadData(true)
            //            if (dxBtFiltre) dxBtFiltre.mRempliCompteur(dxFilter.mGetNbConditionFilter())
            //        }, 0)
            //    }
            //}).dxCtrlFilterGridStrConPage("instance")
        } else {
            if (!option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase) {
                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase = option.bddCtrl.getObjet("filtrestrcon").mGetNewData()
                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase.type_filtre = "simple"
                option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase.type_data = option.typeData
            }
            //$("<div/>").appendTo($DivFilter).dxCtrlFilterSimplePage({
            //    bddCtrl: option.bddCtrl,
            //    typeData: option.typeData,
            //    dataFiltre: option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase,
            //    onValueChanged: function (dataFiltre) {
            //        option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase = dataFiltre
            //        option.bddCtrl.mSaveParaJsonUtilisateur();
            //        Me.mReloadData(true)
            //        mUpdateDxBtFilter()
            //    },
            //    onDemandeClose: function () {
            //        ctrlResize.mHideRight()
            //        dxGrid.mRefresh()
            //    }
            //}).dxCtrlFilterSimplePage("instance")
            if (option.typeData == "activite") {
                window.setTimeout(function () { Me.mReloadData(true) }, 0)
            } else {
                Me.mReloadData(true)
            }
            mUpdateDxBtFilter()
            //} else {
            //    var timeOutReloadFromFilter = null
            //    dxFilter = $("<div style='height:100%;'/>").appendTo($DivFilter).dxCtrlFilterBuilderGestion({
            //        bddCtrl: option.bddCtrl,
            //        context_grid: option.context_grid,
            //        type_data: option.typeData,
            //        idTable: ((typeof option.idTable == "undefined") ? null : option.idTable),
            //        fields: option.fields,
            //        valueDxFilter: option.valueDxFilter,
            //        onValueChanged: function (value) {
            //            //Me.mReloadData(true)
            //            //if (dxBtFiltre) dxBtFiltre.mRempliCompteur(dxFilter.mGetNbConditionFilter())
            //            window.clearTimeout(timeOutReloadFromFilter)
            //            timeOutReloadFromFilter = window.setTimeout(function () {
            //                console.log("reloadfilter");
            //                Me.mReloadData(true)
            //                //if (firstLoadFilter) {
            //                //    firstLoadFilter = false
            //                //    if (dxFilter.mGetNbConditionFilter() > 0 && option.showFilterRempli) {
            //                //        $DivFilter.show()
            //                //        resizeSensorFilterFunc()
            //                //    }
            //                //}
            //                mUpdateDxBtFilter()
            //            }, 200)
            //        },
            //        //onDemandeClose: function () {
            //        //    $DivFilter.slideUp()
            //        //}
            //    }).dxCtrlFilterBuilderGestion("instance")

            //    //var $Td = $("<td style='width:40px;vertical-align:top;'/>").appendTo($Tr)
            //    $("<div style='position:absolute;top:0;z-index:1;right:5px;padding-top:5px;'/>").appendTo($DivFilter).dxCtrlButton({
            //        icon: "fas fa-chevron-down",
            //        onClick: function (e) {
            //            e.event.stopPropagation()
            //            ctrlResize.mHideRight()
            //            dxGrid.mRefresh()
            //            //$DivFilter.slideUp(100, function () { resizeSensorFilterFunc() })
            //        }
            //    })
            //    mUpdateDxBtFilter()
            //    if (firstLoadFilter && dxFilter.mGetNbConditionFilter() > 0 && option.showFilterRempli && showMessageFilterFirstLoading) {
            //        window.setTimeout(function () {
            //            mNotify("Vous avez un filtre sur cette grille.<br/>Cliquer sur <i class='fas fa-filter'></i> ou <a href='javascript:void(0)'>ici</a> pour visualiser le filtre.", "warning", 6000, function () {
            //                if (dxBtFiltre) dxBtFiltre.performClick()
            //            })
            //        }, 1000)
            //    }
        }

        //resizeObserver.mAdd($DivFilter, function () {
        //    dxFilter.element().css({ height: $DivFilter.innerHeight() + "px" })
        //})

    }

    function mUpdateDxBtFilter() {
        if (dxBtFiltre) {
            if (option.typeData == "strcon") {
                var nbCondition = 0
                var txtHideElement = ""
                if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon != null && option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre != null) {
                    var filterClass = new cFilterGeneral(option.bddCtrl, 'strcon')
                    filterClass.mUpdateFiltre(option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre)
                    var cond = JSON.parse(option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.datafiltre.json_lst_condition)
                    nbCondition = filterClass.mGetNbCondtion(cond)

                    if (option.dataGridVue) {
                        var filterGridStrConVue = JSON.parse(option.dataGridVue.filter_json2)
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_str == "0" && filterGridStrConVue.montrer_str == "1") {
                            txtHideElement = "structures"
                        }
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_strcon == "0" && filterGridStrConVue.montrer_strcon == "1") {
                            txtHideElement += ((txtHideElement.length > 0) ? ", " : "") + "structures/contacts"
                        }
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_con == "0" && filterGridStrConVue.montrer_con == "1") {
                            txtHideElement += ((txtHideElement.length > 0) ? ", " : "") + "contacts isolés"
                        }
                    } else {
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_str == "0") {
                            txtHideElement = "structures"
                        }
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_strcon == "0") {
                            txtHideElement += ((txtHideElement.length > 0) ? ", " : "") + "structures/contacts"
                        }
                        if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon.montrer_con == "0") {
                            txtHideElement += ((txtHideElement.length > 0) ? ", " : "") + "contacts isolés"
                        }
                    }
                }

                if (dxBtFiltre) {
                    dxBtFiltre.mRempliCompteur(nbCondition)
                    if (txtHideElement.length > 0) {
                        $("<i class='fas fa-triangle-exclamation' style='color:red;position:absolute;top:5px;left:5px;'></i>").appendTo(dxBtFiltre.element().find(".dx-button-content"))
                        dxBtFiltre.element().attr("title", "les " + txtHideElement + " sont caché dans le filtre.")
                    } else {
                        dxBtFiltre.element().find(".fa-triangle-exclamation").remove()
                        dxBtFiltre.element().attr("title", "")
                    }
                }
                if (firstLoadFilter && (nbCondition > 0 || txtHideElement.length > 0) && option.showFilterRempli && showMessageFilterFirstLoading) {
                    window.setTimeout(function () {
                        mNotify("Vous avez un filtre sur cette grille.<br/>" +
                            (txtHideElement.length > 0 ? "les " + txtHideElement + " sont caché dans le filtre.<br/>" : "") +
                            "Cliquer sur <i class='fas fa-filter'></i> ou <a href='javascript:void(0)'>ici</a> pour visualiser et modifier le filtre.", "warning", 6000, function () {
                                if (dxBtFiltre) dxBtFiltre.performClick()
                            })
                    }, 1000)
                }
                firstLoadFilter = false
            } else {
                var nbCondition = 0
                if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase != null) {
                    var filterClass = new cFilterGeneral(option.bddCtrl, option.typeData)
                    filterClass.mUpdateFiltre(option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase)
                    var cond = JSON.parse(option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase.json_lst_condition)
                    nbCondition = filterClass.mGetNbCondtion(cond)
                }

                if (dxBtFiltre) dxBtFiltre.mRempliCompteur(nbCondition)
                if (firstLoadFilter && nbCondition > 0 && option.showFilterRempli && showMessageFilterFirstLoading) {
                    window.setTimeout(function () {
                        mNotify("Vous avez un filtre sur cette grille.<br/>Cliquer sur <i class='fas fa-filter'></i> ou <a href='javascript:void(0)'>ici</a> pour visualiser le filtre.", "warning", 6000, function () {
                            if (dxBtFiltre) dxBtFiltre.performClick()
                        })
                    }, 1000)
                }
                firstLoadFilter = false
                //} else {
                //    dxBtFiltre.mRempliCompteur(dxFilter.mGetNbConditionFilter())
            }
        }
    }

    function mShowFilterStrCon() {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            hideOnOutsideClick: true,
            width: 750,
            height: "100%",
            showTitle: true,
            showMaximize: true,
            showMinimize: false,
            title: "Filtrer vos fiches",
            resizeEnabled: true,
            shading: false,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0px")
                $("<div/>").appendTo(contentElement).dxCtrlFilterStrConPage({
                    bddCtrl: option.bddCtrl,
                    dataFiltreGridStrCon: option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon,
                    dataGridVue: option.dataGridVue,
                    conditionsCache: option.conditionsCache,
                    afficheClickListe: false,
                    typeData: "strcon",
                    onValueChanged: function (dataFiltreGridStrCon) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon = dataFiltreGridStrCon
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        mUpdateDxBtFilter()
                        Me.mReloadData(false)
                    },
                    //onValueChangedIa: function (lstIdTableId) {
                    //    Me.mChangeLstIdTableIdInclu(lstIdTableId,true)
                    //}
                }).dxCtrlFilterStrConPage("instance")
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    function mShowFilterAutre() {
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            position: {
                my: "right top",
                at: "right top",
                of: "body"
            },
            hideOnOutsideClick: true,
            width: 550,
            height: "100%",
            showTitle: true,
            showMaximize: true,
            showMinimize: false,
            title: "Filtrer la grille",
            resizeEnabled: true,
            shading: false,
            contentTemplate: function (contentElement) {
                contentElement.css("padding-top", "0px")
                $("<div/>").appendTo(contentElement).dxCtrlFilterSimplePage({
                    bddCtrl: option.bddCtrl,
                    typeData: option.typeData,
                    dataFiltre: option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase,
                    onValueChanged: function (dataFiltre) {
                        option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase = dataFiltre
                        option.bddCtrl.mSaveParaJsonUtilisateur();
                        Me.mReloadData(true)
                        mUpdateDxBtFilter()
                    }
                }).dxCtrlFilterSimplePage("instance")
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    var showMessageFilterFirstLoading = true
    var dxGrid = null
    function mConstruitGrid() {
        Me.txtSearchLucene = ""

        var opt = {
            bddCtrl: option.bddCtrl,
            context_grid: option.context_grid,
            allow_columnchooser: option.allow_columnchooser,
            typeData: option.typeData,
            dataGridVue: option.dataGridVue,
            nomTemplateDisplay: option.nomTemplateDisplay,
            nomTemplateIco: option.nomTemplateIco,
            nomTemplatePlus: option.nomTemplatePlus,
            getItemTemplateHeight: option.getItemTemplateHeight,
            lstTypeGrille: option.lstTypeGrille,
            allowCheck: option.allowCheck,
            allowCarto: option.allowCarto,
            showColumnHeaders: option.showColumnHeaders,
            fields: option.fields,
            noPagination: option.noPagination,
            hideEntete: option.hideEntete,
            hideItemPlus: option.hideItemPlus,
            hideRound: option.hideRound,
            noDataText: option.noDataText,
            allowModifTemplateStrCon: option.allowModifTemplateStrCon,
            onDisplayButtonLigne: option.onDisplayButtonLigne,
            itemTemplateGrille: option.itemTemplateGrille,
            itemTemplateGrillePlus: option.itemTemplateGrillePlus,
            itemTemplateIco: option.itemTemplateIco,
            allowGroup: option.allowGroup,
            onHoverDataGrid: option.onHoverDataGrid,
            dxVirtualGrid: Me,
            getAlignItem: option.getAlignItem,
            optionTemplate: option.optionTemplate,
            grilleBackgroundColor: option.grilleBackgroundColor,
            isForDoublon: option.isForDoublon,
            paddingLeftRightRow: option.paddingLeftRightRow,
            onDemandeData: function (funcOk) {
                mGetData(function (lstData) {
                    funcOk(lstData)
                })
            },
            onDemandeReloadData: function () {
                Me.mReloadData()
            },
            onSelectionChanged: function (lstSelectedData, lstData) {
                onSelectionChanged()
            },
            onToolbarPreparing: function (e) {
                mConstruitToolbar(e.toolbarOptions)
            },
            showPager: option.showPager,
            onDemandeReconstruit: function () {
                showMessageFilterFirstLoading = false
                mConstruit()
                showMessageFilterFirstLoading = true
            },
            onFirstContentReady: function (e) {
                if (!option.allowFilter) window.setTimeout(function () { Me.mReloadData() });
                if (typeof option.onFirstContentReady != 'undefined') option.onFirstContentReady(e)
                if (option.checkActive) {
                    window.setTimeout(function () { dxBtCheck.performClick() }, 1000)
                    //dxBtCheck.performClick()
                }
            },
        }
        if (option.allowClick || typeof option.onClickDataGrid != 'undefined') {
            if (typeof option.onClickDataGrid != 'undefined' && option.onClickDataGrid != null) {
                opt.onClickDataGrid = function (container, dataGrid, dataTemplate) {
                    option.onClickDataGrid(container, dataGrid, dataTemplate)
                    if (typeof option.onEndClickDataGrid != 'undefined') option.onEndClickDataGrid(dataGrid, dataTemplate)
                    //window.setTimeout(function () { container.removeAttr("tabindex") }, 0)
                }
            } else {
                opt.onClickDataGrid = function (container, dataGrid, dataTemplate) {
                    var table = option.bddCtrl.table.mGetItem(dataGrid.id_table)
                    var obj = option.bddCtrl.getObjet(table.nom, dataGrid.id)
                    if (typeof obj.data != 'undefined') obj.mShowPopup()
                    if (typeof option.onEndClickDataGrid != 'undefined') option.onEndClickDataGrid(dataGrid, dataTemplate)
                    //window.setTimeout(function () { container.removeAttr("tabindex") }, 0)
                }
            }
        }

        dxGrid = $("<div class='dxvirtualgrid" + ((option.readOnly) ? "" : "modif") + "'/>").appendTo($DivGrid).dxCtrlGrid(opt).dxCtrlGrid("instance")
    }

    function mChangeSelection() {

    }

    this.mSwitchCheck = function () { dxGrid.mSwitchCheck() }
    this.mGetModeSelection = function () { return dxGrid.mGetModeSelection() }

    this.mGetDxChkSelect = function () { return dxChkSelect }
    function onSelectionChanged() {
        if (dxBtCheck && dxGrid) {
            var nb = dxGrid.mGetLstSelectedData().length
            dxBtCheck.mRempliCompteur(nb)
            if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille != "carto") {
                dxBtCheck.element().attr("title", "Activer/désactiver la sélection" + ((nb > 0) ? "<br/>" + nb + " éléments sélectionnés" : ""))
            } else {
                dxBtCheck.element().attr("title", "Cacher/Montrer les actions" + ((nb > 0) ? "<br/>" + nb + " éléments affichés" : ""))
            }
            Me.lstButtonForCheck.forEach(function (dxBt) {
                dxBt.option("disabled", (nb == 0))
            })
        }
        if (!$TdTextSelect || !dxGrid) return
        var lstData = dxGrid.mGetLstData()
        var lstSelectedData = null
        if (typeof option.onDisplayLstSelect != 'undefined') {
            option.onDisplayLstSelect($TdTextSelect)
        } else {
            var lstSelectedData = null
            if (dxChkSelect && dxGrid.mGetModeSelection() == "multiple") {
                lstSelectedData = dxGrid.mGetLstSelectedData()
                $TdTextSelect.html("<span>" + lstSelectedData.length + "<span style='opacity:0.3'>&nbsp;/&nbsp;</span>" + lstData.length + "</span>")
            } else {
                $TdTextSelect.html("<span></span><span>" + lstData.length + "</span>")
            }
        }
        if (dxChkSelect && dxGrid.mGetModeSelection() == "multiple") {
            if (!lstSelectedData) lstSelectedData = dxGrid.mGetLstSelectedData()
            dxChkSelect.disableValueChanged = true
            if (lstSelectedData.length == lstData.length && lstData.length != 0) { dxChkSelect.option("value", true) }
            else if (lstSelectedData.length == 0) { dxChkSelect.option("value", false) }
            else { dxChkSelect.option("value", null) }
            dxChkSelect.disableValueChanged = false
        }

        if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged()
    }

    var $TdTextSelect = null
    var dxChkSelect = null
    var dxBtFiltre = null
    var dxBtSuppTot = null
    this.txtSearchLucene = ""
    this.lstIdTableIdLucene = null
    var itemToolBarPersoData = null
    this.toolbarSelectIsVisible = false
    var dxBtCheck = null
    this.lstButtonForCheck = []
    this.lstItemToolbarForCheck = []
    this.toolbarSelectIsVisible = false
    function mConstruitToolbar(toolbarOptions) {
        if (!option.allowToolbar) {
            toolbarOptions.visible = false
            //dxGrid.mGetToolbar().option("visible", false)
        } else {
            //ajoute carto
            if (option.allowCarto) {
                var item = getToolbarSeparator("after", "auto")
                //toolbarOptions.items.splice(1, 0, item)
                toolbarOptions.items.splice(1, 0, {
                    location: 'after',
                    locateInMenu: 'auto',
                    widget: 'dxButton',
                    showText: "inMenu",
                    options: {
                        icon: 'fas fa-map',
                        text: "Cartographie",
                        hint: "Afficher la cartographie de votre base de données",
                        focusStateEnabled: false,
                        onClick() {
                            option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = "carto"
                            option.bddCtrl.mSaveParaJsonUtilisateur();
                            Me.toolbarSelectIsVisible = false
                            mConstruit()
                        },
                        onContentReady: function (e) {
                            if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "carto") e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorAccent)
                            //e.component.element().find(".dx-icon").css("position", "relative")
                            //$("<i class='fas fa-pen dxicon2' style='position:absolute;bottom:-3.6px;right:-3.6px;font-size:12px;opacity:0.9;color:" + theme.colorBtIcon2 + ";'></i>").appendTo($(e.component.element().find(".dx-icon")))
                            e.component.element().attr("title", "Cartographie")
                        }
                    },
                })
                //var item = getToolbarSeparator("after", "auto")
                //toolbarOptions.items.splice(1, 0, item)
            }
            //ajout choix grille
            if ((!option.allowCarto && option.lstTypeGrille.length > 1) || (option.allowCarto && option.lstTypeGrille.length >= 1)) {
                if (option.lstTypeGrille.contains("Modif")) {
                    toolbarOptions.items.splice(1, 0, {
                        location: 'after',
                        locateInMenu: 'auto',
                        widget: 'dxButton',
                        showText: "inMenu",
                        options: {
                            icon: 'fas fa-list',
                            text: "Vue modification",
                            hint: "Vue modification",
                            focusStateEnabled: false,
                            onClick() {
                                try {
                                    throw new Error("Chargement grille modif strcon");
                                } catch (e) {
                                    mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                                }
                                option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = "Modif"
                                option.bddCtrl.mSaveParaJsonUtilisateur();
                                Me.toolbarSelectIsVisible = false
                                mConstruit()
                            },
                            onContentReady: function (e) {
                                if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "Modif") e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorAccent)
                                e.component.element().find(".dx-icon").css("position", "relative")
                                $("<i class='fas fa-pen dxicon2' style='position:absolute;bottom:-3.6px;right:-3.6px;font-size:12px;opacity:0.9;color:" + theme.colorBtIcon2 + ";'></i>").appendTo($(e.component.element().find(".dx-icon")))
                                e.component.element().attr("title", "Grille de modification")
                            }
                        },
                    })
                }
                if (option.lstTypeGrille.contains("Excel")) {
                    toolbarOptions.items.splice(1, 0, {
                        location: 'after',
                        locateInMenu: 'auto',
                        widget: 'dxButton',
                        showText: "inMenu",
                        options: {
                            icon: 'fas fa-table-cells',
                            text: "Vue excel",
                            focusStateEnabled: false,
                            onClick() {
                                option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = "Excel"
                                option.bddCtrl.mSaveParaJsonUtilisateur();
                                Me.toolbarSelectIsVisible = false
                                mConstruit()
                            },
                            onContentReady: function (e) {
                                if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "Excel") e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorAccent)
                                e.component.element().attr("title", "Grille excel")
                            }
                        },
                    })
                }
                if (option.lstTypeGrille.contains("Lignes")) {
                    toolbarOptions.items.splice(1, 0, {
                        location: 'after',
                        locateInMenu: 'auto',
                        widget: 'dxButton',
                        showText: "inMenu",
                        options: {
                            icon: 'fas fa-list',
                            text: "Vue lignes",
                            hint: "Grille lignes",
                            focusStateEnabled: false,
                            onClick() {
                                option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = "Lignes"
                                option.bddCtrl.mSaveParaJsonUtilisateur();
                                Me.toolbarSelectIsVisible = false
                                mConstruit()
                            },
                            onContentReady: function (e) {
                                if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "Lignes") e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorAccent)
                            }
                        },
                    })
                }
                if (option.lstTypeGrille.contains("Détails") && typeof option.dataGridVue == 'undefined') {
                    toolbarOptions.items.splice(1, 0, {
                        location: 'after',
                        locateInMenu: 'auto',
                        widget: 'dxButton',
                        showText: "inMenu",
                        options: {
                            icon: 'fas fa-rectangle-list',
                            text: "Vue détails",
                            hint: "Grille détails",
                            focusStateEnabled: false,
                            onClick() {
                                option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille = "Détails"
                                option.bddCtrl.mSaveParaJsonUtilisateur();
                                Me.toolbarSelectIsVisible = false
                                mConstruit()
                            },
                            onContentReady: function (e) {
                                if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "Détails") e.component.element().find(".dx-button-content").css("background-color", theme.backgroundcolorAccent)
                            }
                        },
                    })
                }
            }

            //ajoute recherche
            toolbarOptions.items.splice(0, 0, {
                location: 'after',
                locateInMenu: 'auto',
                template: function (itemData, itemIndex, itemElement) {
                    itemElement.css("vertical-align", "top")
                    if (option.allowLucene) {
                        $("<div class='barlow'/>").appendTo(itemElement).dxTextBox({
                            labelMode: "floating",
                            label: "Rechercher dans la grille...",
                            value: Me.txtSearchLucene,
                            showClearButton: true,
                            width: "100%",
                            onValueChanged: function (e) {
                                Me.txtSearchLucene = ((e.value == null) ? "" : e.value)
                                //le mUpdateSearchLucene peut lancer le rechergement si c'est la première recherche quand opn remove les sorts et groupe
                                //du coup, on vérfie si un mgetdata a été fait dans le mUpdateSearchLucene
                                //si c'est le case, pas besoin de recharger les données
                                mGetDataExe = false
                                dxGrid.mUpdateSearchLucene(Me.txtSearchLucene, e.component)
                                if (!mGetDataExe) Me.mReloadData(true)
                            },
                            onKeyDown: function (e) {
                                if (e.event.keyCode == 13) { e.component.blur() }
                            },
                            onContentReady: function (e) {
                                //e.component.element().find(".dx-placeholder").css("top", "-7px")
                                e.element.find(".dx-texteditor-input").css("padding", "5px")
                                e.element.find(".dx-texteditor-label").css("font-family", "barlow condensed")
                                e.element.find(".dx-texteditor-label").css("font-size", "95%")
                            }
                        })
                    }
                    var $Table = $("<table style='width:100%;'/>").appendTo(itemElement)
                    //if (option.allowLucene) $Table.css({ "scale": "0.9", "display": "inline-block", "width": "105%" })
                    var $Tr = $("<tr/>").appendTo($Table)
                    ////if (option.allowFilter) {
                    ////    var $Td = $("<td style='width:1px;padding-right:5px;'><i class='fas fa-filter state-hover dx-theme-accent-as-text-color' style='border-radius:50%;padding:3px;font-size:120%;'></i></td>").appendTo($Tr)
                    ////    $Td.on("click", function (e) { if ($DivFilter.is(":visible")) { $DivFilter.slideUp() } else { $DivFilter.slideDown() } })
                    ////    $Td.attr("title", "Afficher/cacher le filtre")
                    ////}
                    //var $Td = $("<td style='width:1px;padding-right:5px;'><i class='fas fa-refresh state-hover dx-theme-accent-as-text-color' style='border-radius:50%;padding:3px;font-size:120%;'></i></td>").appendTo($Tr)
                    //$Td.on("click", function (e) { Me.mReloadData(true) })
                    //$Td.attr("title", "Recharger les données")
                    if (typeof option.showColumnHeaders == 'undefined' || option.showColumnHeaders) {
                        var $Td = $("<td style='width:1px;padding-right:5px;'><i class='fas fa-eraser state-hover dx-theme-accent-as-text-color' style='border-radius:50%;padding:3px;font-size:120%;'></i></td>").appendTo($Tr)
                        $Td.on("click", function (e) { dxGrid.mReinitState() })
                        $Td.attr("title", "Réinitialiser la grille<br/>dans son état initial")
                    }
                    $TdTextSelect = $("<td style='width:100%;text-align:right;font-family:barlow condensed;'>0/0</td>").appendTo($Tr)
                    //console.log("$TdTextSelect")
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    //if (option.allowCheck) {
                    //    dxChkSelect = $("<div style=''/>").appendTo($Td).dxCheckBox({
                    //        focusStateEnabled: false,
                    //        text: "",
                    //        value: false,
                    //        onValueChanged: function (e) {
                    //            if (dxChkSelect.disableValueChanged) return
                    //            dxChkSelect.disableValueChanged = true
                    //            dxGrid.mChangeSelectAll(e.value)
                    //            dxChkSelect.disableValueChanged = false
                    //        },
                    //        onContentReady: function (e) { e.component.disableValueChanged = false }
                    //    }).dxCheckBox("instance")
                    //    dxChkSelect.element().hide()
                    //}
                    onSelectionChanged()
                }
            })

            toolbarOptions.items.splice(0, 0, {
                location: 'after',
                locateInMenu: 'auto',
                template: function (itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-refresh",
                        hint: "Recharger la grille",
                        focusStateEnabled: false,
                        onClick: function (e) {
                            Me.mReloadData(true)
                        }
                    }).dxCtrlButton("instance")
                }
            })

            if (option.allowFilter) {
                toolbarOptions.items.splice(0, 0, {
                    location: 'after',
                    locateInMenu: 'auto',
                    template: function (itemData, itemIndex, itemElement) {
                        dxBtFiltre = $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-filter",
                            hint: "Afficher/cacher les filtres",
                            focusStateEnabled: false,
                            onClick: function (e) {
                                if (option.typeData == "strcon") {
                                    //$DivFilter.slideDown()
                                    mShowFilterStrCon()
                                } else {
                                    mShowFilterAutre()
                                    //if (ctrlResize.isRightVisible()) {
                                    //    ctrlResize.mHideRight()
                                    //    dxGrid.mRefresh()
                                    //} else { ctrlResize.mShowRight() }
                                }
                                //if ($DivFilter.is(":visible")) { $DivFilter.slideUp() } else { $DivFilter.slideDown() }
                                //resizeSensorFilterFunc()
                            }
                        }).dxCtrlButton("instance")
                    }
                })
            }

            if (typeof option.onDefineOptionIa != 'undefined') {
                toolbarOptions.items.splice(0, 0, {
                    location: 'after',
                    locateInMenu: 'auto',
                    template: function (itemData, itemIndex, itemElement) {
                        $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fafa fafa-mia",
                            hint: ((typeof option.hintIa == "undefined") ? "Poser une question à MIA sur les données" : option.hintIa),
                            focusStateEnabled: false,
                            onClick: function (e) {
                                mShowIa()
                            }
                        }).dxCtrlButton("instance")
                    }
                })
            }

            if (typeof option.itemsToolbar != 'undefined' && option.itemsToolbar.length > 0) {
                if (toolbarOptions.items.filter(function (o) { return o.location == "before" }).length > 1) toolbarOptions.items.unshift(getToolbarSeparator("before", "auto"))
                option.itemsToolbar.reverse().forEach(function (item) { toolbarOptions.items.unshift(item) })
                //ajoute suppall
            }

            if (option.allowCheck) {
                toolbarOptions.items.unshift(getToolbarSeparator("before", "auto"))
                var itemTooBarCheck = {
                    location: 'before',
                    visible: true,
                    template: function (itemData, itemIndex, itemElement) {
                        itemElement.closest(".dx-toolbar-item-content").css("background-color", theme.backgroundcolorTooltip)
                        itemElement.closest(".dx-toolbar-item-content").css("border-radius", "5px")
                        itemElement.closest(".dx-toolbar-item-content").css("padding", "5px")
                        itemElement.closest(".dx-toolbar-item").css("padding-left", "8px")
                        dxBtCheck = $("<div/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-gamepad",
                            icon2: ((dxGrid != null && dxGrid.mGetModeSelection() == "multiple") ? "fas fa-arrow-left" : "fas fa-arrow-right"),
                            colorIcone2: theme.backgroundcolorAccent,
                            txtTooltip: "Activer/désactiver la sélection",
                            onClick: function (e) {
                                dxBtCheck.option("icon2", "fas fa-arrow-left")
                                if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "carto") {
                                    Me.toolbarSelectIsVisible = !Me.toolbarSelectIsVisible
                                    if (Me.toolbarSelectIsVisible) {
                                        if (dxBtSuppTot) dxBtSuppTot.element().closest(".dx-toolbar-button").show()
                                        if (dxChkSelect) dxChkSelect.element().show()
                                        e.component.element().css("margin-right", "10px")
                                        dxGrid.mChangeSelectAll(true)
                                    } else {
                                        if (dxBtSuppTot) dxBtSuppTot.element().closest(".dx-toolbar-button").hide()
                                        if (dxChkSelect) dxChkSelect.element().hide()
                                        e.component.element().css("margin-right", "0px")
                                    }
                                    Me.lstItemToolbarForCheck.forEach(function (itemToolBar) {
                                        itemToolBar.visible = Me.toolbarSelectIsVisible
                                    })
                                    Me.lstButtonForCheck.forEach(function (dxBt) {
                                        if (Me.toolbarSelectIsVisible) {
                                            dxBt.element().closest(".dx-toolbar-button").show()
                                        } else {
                                            dxBt.element().closest(".dx-toolbar-button").hide()
                                        }
                                    })
                                    if (typeof option.onShowHideCheck != 'undefined') {
                                        option.onShowHideCheck(Me.toolbarSelectIsVisible)
                                    }
                                } else {
                                    dxGrid.mSwitchCheck()
                                    if (dxGrid.mGetModeSelection() == "multiple") {
                                        if (dxBtSuppTot) dxBtSuppTot.element().closest(".dx-toolbar-button").show()
                                        if (dxChkSelect) dxChkSelect.element().show()
                                        e.component.element().css("margin-right", "10px")
                                        dxGrid.mChangeSelectAll(true)
                                    } else {
                                        if (dxBtSuppTot) dxBtSuppTot.element().closest(".dx-toolbar-button").hide()
                                        if (dxChkSelect) dxChkSelect.element().hide()
                                        e.component.element().css("margin-right", "0px")
                                    }
                                    Me.toolbarSelectIsVisible = (dxGrid.mGetModeSelection() == "multiple")
                                    Me.lstItemToolbarForCheck.forEach(function (itemToolBar) {
                                        itemToolBar.visible = Me.toolbarSelectIsVisible
                                    })
                                    Me.lstButtonForCheck.forEach(function (dxBt) {
                                        if (Me.toolbarSelectIsVisible) {
                                            dxBt.element().closest(".dx-toolbar-button").show()
                                        } else {
                                            dxBt.element().closest(".dx-toolbar-button").hide()
                                        }
                                    })
                                    if (typeof option.onShowHideCheck != 'undefined') {
                                        option.onShowHideCheck(dxGrid.mGetModeSelection() == "multiple")
                                    }
                                }

                                window.setTimeout(function () { dxGrid.mGetToolbar().repaint() }, 0)
                            },
                            onContentReady: function (e) {
                                //if (dxGrid != null && dxGrid.mGetModeSelection() == "multiple") {
                                //    e.component.element().css("margin-right", "10px")
                                //} else {
                                //    e.component.element().css("margin-right", "0px")
                                //}
                            }
                        }).dxCtrlButton("instance")
                    }
                }
                //Me.lstItemToolbarForCheck.push(itemTooBarCheck)
                toolbarOptions.items.unshift(itemTooBarCheck)
                //toolbarOptions.items.unshift({
                //    location: 'before',
                //    template: function (itemData, itemIndex, itemElement) {
                //        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                //        dxChkSelect = $("<div style='padding:0 10px;'/>").appendTo(itemElement).dxCheckBox({
                //            focusStateEnabled: false,
                //            text: "",
                //            value: false,
                //            onValueChanged: function (e) {
                //                if (dxChkSelect.disableValueChanged) return
                //                dxChkSelect.disableValueChanged = true
                //                dxGrid.mChangeSelectAll(e.value)
                //                dxChkSelect.disableValueChanged = false
                //            },
                //            onContentReady: function (e) { e.component.disableValueChanged = false }
                //        }).dxCheckBox("instance")
                //        dxChkSelect.element().hide()
                //    }
                //})
            }

            Me.lstButtonForCheck = []
            Me.lstItemToolbarForCheck = []
            if (typeof option.allowDeleteInToolbar == 'undefined' || option.allowDeleteInToolbar) {
                //supall
                //toolbarOptions.items.unshift(getToolbarSeparator("before", "auto"))
                var itemToolbarDelete = {
                    location: 'before',
                    visible: Me.toolbarSelectIsVisible,
                    template: function (itemData, itemIndex, itemElement) {
                        //itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                        var dxBtSuppTot = $("<div style='display:none;'/>").appendTo(itemElement).dxCtrlButton({
                            icon: "fas fa-trash-alt",
                            txtTooltip: "Supprimer tous les éléments de la grille",
                            onClick: function (e) {
                                Me.mDelAll(e.component.element())
                            },
                            onContentReady: function (e) {
                                if (!Me.toolbarSelectIsVisible) itemElement.closest(".dx-toolbar-button").hide()
                                window.setTimeout(function () { e.component.element().closest(".dx-ctrlbutton").css("display", "") }, 0)
                            }
                        }).dxCtrlButton("instance")
                        //dxBtSuppTot.element().hide()
                        Me.lstButtonForCheck.push(dxBtSuppTot)
                    }
                }
                Me.lstItemToolbarForCheck.push(itemToolbarDelete)
                toolbarOptions.items.unshift(itemToolbarDelete)
            }

            if (typeof option.itemsToolbarSelect != 'undefined' ||
                typeof option.allowDeleteInToolbar == 'undefined' || option.allowDeleteInToolbar) {
                if (option.itemsToolbarSelect) option.itemsToolbarSelect(Me).reverse().forEach(function (item) { toolbarOptions.items.unshift(item) })

                //if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille != "carto") {
                toolbarOptions.items.unshift({
                    location: 'before',
                    template: function (itemData, itemIndex, itemElement) {
                        //itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
                        dxChkSelect = $("<div style='padding:0 10px 0 10px;display:none;'/>").appendTo(itemElement).dxCheckBox({
                            focusStateEnabled: false,
                            text: "",
                            value: false,
                            visible: option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille != "carto",
                            onValueChanged: function (e) {
                                if (dxChkSelect.disableValueChanged) return
                                dxChkSelect.disableValueChanged = true
                                dxGrid.mChangeSelectAll(e.value)
                                dxChkSelect.disableValueChanged = false
                            },
                            onContentReady: function (e) {
                                e.component.disableValueChanged = false
                                if (!Me.toolbarSelectIsVisible) itemElement.closest(".dx-toolbar-button").hide()
                                window.setTimeout(function () { e.component.element().closest(".dx-checkbox").css("display", "") }, 0)
                            }
                        }).dxCheckBox("instance")
                        if (!Me.toolbarSelectIsVisible) window.setTimeout(function () { dxChkSelect.element().closest(".dx-toolbar-button").hide() }, 0)
                    }
                })
                //}
            }

            //window.setTimeout(function () { toolbar.option("items", items) }, 500)
        }
    }

    this.mDelAll = function (target) {
        var lstDataTraitement = dxGrid.mGetLstSelectedData()
        if (lstDataTraitement.length == 0) lstDataTraitement = dxGrid.mGetLstData()
        lstDataTraitement = lstDataTraitement.filter(function (o) { return o.id_table != option.bddCtrl.table.mGetItemFromNom("compte_client").id_table && o.id_table != option.bddCtrl.table.mGetItemFromNom("compte_client_utilisateur").id_table })

        if (lstDataTraitement.length > 0) {
            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                target: target,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "24px");
                    $("<div>Mettre à la corbeile " + lstDataTraitement.length + " élément" + ((lstDataTraitement.length > 1) ? "s" : "") + "</div>").appendTo(contentElement)
                    $("<div style='margin-top:20px;'/>").appendTo(contentElement).dxCtrlButton({
                        text: "Confirmer",
                        onClick: function (e) {
                            tt.hide()
                            if (lstDataTraitement.length <= 10) {
                                Me.activeOnModifiedItemData = false
                                jaugeDemarrage.mShow();

                                var data = []
                                lstDataTraitement.forEach(function (ligne) {
                                    data.push({
                                        id_table: ligne.id_table,
                                        id: ligne.id
                                    })
                                })
                                var funcDelete = function (idx) {
                                    if (typeof data[idx] == 'undefined') {
                                        jaugeDemarrage.mHide();
                                        Me.activeOnModifiedItemData = true
                                        mNotify("Les données ont été mises à la corbeille.", "success", 6000)
                                        dxGrid.mUpdateData()
                                        if (option.bddCtrl.msgEmailSms) option.bddCtrl.msgEmailSms.mGetData(true)
                                    } else {
                                        var nomTable = option.bddCtrl.table.mGetItem(data[idx].id_table).nom
                                        var obj = option.bddCtrl.getObjet(nomTable, data[idx].id)
                                        obj.mDelData(function () {
                                            //dxGrid.mRemoveRow(lstData[idx])
                                            funcDelete(idx + 1)
                                        }, null, true, null, function () {
                                            jaugeDemarrage.mHide();
                                            Me.activeOnModifiedItemData = true
                                            mNotify("Une erreur s'est produite durant la mise à la corbeille. Une partie des données n'a pas été mise à la corbeille.", "error", 6000)
                                            dxGrid.mUpdateData()
                                            if (option.bddCtrl.msgEmailSms) option.bddCtrl.msgEmailSms.mGetData(true)
                                        })
                                    }
                                }
                                funcDelete(0)
                            } else {
                                var data = []
                                lstDataTraitement.forEach(function (ligne) {
                                    data.push({
                                        id_table: ligne.id_table,
                                        id: ligne.id
                                    })
                                })
                                var trait = new cTraitementBloquantSession(option.bddCtrl, {
                                    nom_type_traitement: "deldanscorbeillelot",
                                    data: data
                                }, {
                                    onFinTraitement: function () {
                                        if (option.bddCtrl.msgEmailSms) option.bddCtrl.msgEmailSms.mGetData(true)
                                    }
                                });
                            }
                        }
                    })
                }
            }).dxCtrlTooltip("instance");
            tt.show();
        }

    }

    this.mUpdateSearchLucene = function (txtSearch, dxTextBox) {
        Me.txtSearchLucene = ((txtSearch == null) ? "" : txtSearch)
        mGetDataExe = !option.hideEntete // false
        dxGrid.mUpdateSearchLucene(Me.txtSearchLucene, dxTextBox)
        if (!mGetDataExe) Me.mReloadData(true)
        //dxGrid.mUpdateSearchLucene(txtSearch, dxCtrlRecherche)
    }

    this.mChangeSelectAll = function (selectAll) { dxGrid.mChangeSelectAll(selectAll) }
    this.mRepaintRow = function (dataGrid, rechargeTemplate) { dxGrid.mRepaintRow(dataGrid, rechargeTemplate) }
    this.mRemoveRows = function (lstDataGrid) { dxGrid.mRemoveRows(lstDataGrid) }
    this.mRemoveRow = function (dataGrid) { dxGrid.mRemoveRow(dataGrid) }
    this.mGetLstData = function () { return dxGrid.mGetLstData() }
    this.mGetLstSelectedData = function () { return dxGrid.mGetLstSelectedData() }
    this.mGetLstTraitementData = function () {
        if (this.mGetLstSelectedData().length > 0) { return this.mGetLstSelectedData() }
        else { return this.mGetLstData() }
    }
    this.mUpdateData = function (action, idTable, id) {
        if (container.closest("body").length == 0) return
        dxGrid.mUpdateData(action, idTable, id)
    }
    this.mChangeLstIdTableIdExclu = function (lstIdTableId, reload, animate) {
        if (container.closest("body").length == 0) return
        if (typeof animate == "undefined") animate = true
        if (typeof reload == "undefined") reload = true
        option.lstIdTableIdExclu = lstIdTableId
        if (reload) this.mReloadData(animate)
    }
    this.mChangeLstIdTableIdInclu = function (lstIdTableId, reload, animate) {
        if (container.closest("body").length == 0) return
        if (typeof animate == "undefined") animate = true
        if (typeof reload == "undefined") reload = true
        option.lstIdTableIdInclu = lstIdTableId
        if (reload) this.mReloadData(animate)
    }
    this.mReloadData = function (animate) {
        //ctrlResize.element().show()
        jaugeGrid.mShow()
        if (container.closest("body").length == 0) return
        if (reqGetData != null) reqGetData.abort()
        mGetData(function (lstData) {
            if (container.closest("body").length == 0) return
            dxGrid.mReloadData(lstData, animate)
            jaugeGrid.mHide()
        })
    }

    this.mGetDataCount = function (funcOk) {
        mGetData(funcOk, true)
    }

    var reqGetData = null
    var mGetDataExe = false
    function mGetData(funcOk, getCount) {
        if (typeof getCount == 'undefined') getCount = false
        mGetDataExe = true
        var tabIdTableIdExclu = null
        if (typeof option.lstIdTableIdExclu != 'undefined') {
            tabIdTableIdExclu = []
            option.lstIdTableIdExclu.forEach(function (idTableId) {
                if (idTableId.id_table != null) {
                    var tabIdTableId = tabIdTableIdExclu.filter(function (o) { return o.id_table == idTableId.id_table })[0]
                    if (typeof tabIdTableId == 'undefined') {
                        tabIdTableIdExclu.push({ id_table: idTableId.id_table, lstid: idTableId.id + "" })
                    } else { tabIdTableId.lstid += "," + idTableId.id }
                }
            })
        }
        var tabIdTableIdInclu = null
        if (option.lstIdTableIdInclu) {
            tabIdTableIdInclu = []
            if (option.lstIdTableIdInclu.length == 0) {
                //on veux rien inclure
                //si on ne fait pas cela, on affichera tout (alors que l'on ne veux rien afficher)
                tabIdTableIdInclu.push({ id_table: 0, lstid: "0" })
            } else {
                option.lstIdTableIdInclu.forEach(function (idTableId) {
                    if (idTableId.id_table != null) {
                        var tabIdTableId = tabIdTableIdInclu.filter(function (o) { return o.id_table == idTableId.id_table })[0]
                        if (typeof tabIdTableId == 'undefined') {
                            tabIdTableIdInclu.push({ id_table: idTableId.id_table, lstid: idTableId.id + "" })
                        } else { tabIdTableId.lstid += "," + idTableId.id }
                    }
                })
            }
        }

        var filterTot = null
        if (option.typeData == "strcon") {
            filterTot = {
                lstFilter: [[]]
            }
            //filterTot = dxFilter.mGetLstFilterForServeurWithDataGridVue()
        } else {
            filterTot = ((dxFilter && dxFilter.mGetLstFilterForServeur() != null) ? dxFilter.mGetLstFilterForServeur() : {
                lstFilter: [[]]
            })
        }
        //if (typeof option.dataGridVue != 'undefined' && option.typeData == "strcon" && option.allowFilter) {
        //    filterTot = dxFilter.mGetLstFilterForServeurWithDataGridVue()
        //} else {
        //    filterTot = ((dxFilter && dxFilter.mGetLstFilterForServeur() != null) ? dxFilter.mGetLstFilterForServeur() : {  
        //        lstFilter: [[]]
        //    })
        //}

        if (option.lstLstConditionBase.length > 0) {
            filterTot.lstFilter.forEach(function (tabFiltersOr) {
                if (tabFiltersOr.length == 0) {
                    tabFiltersOr.push({
                        id_table: null,
                        unitaire: "1",
                        filters: JSON.parse(JSON.stringify(option.lstLstConditionBase))
                    })
                } else {
                    tabFiltersOr.forEach(function (tabFiltersEt) {
                        var newLstFilter = []
                        if (typeof tabFiltersEt.filters != 'undefined') {
                            if (tabFiltersEt.filters.length == 0) tabFiltersEt.filters = [[]]
                            tabFiltersEt.filters.forEach(function (filter, idx) {
                                option.lstLstConditionBase.forEach(function (lstCondition, idx2) {
                                    var newFilter = filter.clone()
                                    lstCondition.forEach(function (cond) {
                                        newFilter.push(cond)
                                    })
                                    newLstFilter.push(newFilter)
                                })
                            })
                            tabFiltersEt.filters = newLstFilter
                        }

                    })
                }
            })
        }
        console.log("load data")
        var dataToBeSent = {
            command: ((getCount) ? "loaddatagridcount" : "loaddatagrid"),
            path: option.path, //pour le filemanager
            txt_for_search_bdd: option.txt_for_search_bdd, //pour la recherche sur la page principale (uniq pour searchbdd)
            type_data: option.typeData,
            //lst_condition_base: [],
            sql: "(1=1)",
            sql_str_for_strcon: "(1=1)",
            filters: filterTot,
            field_group_sort: ((getCount) ? [] : dxGrid.mGetLstFieldGrpSort()),
            txt_search_lucene: ((getCount) ? "" : Me.txtSearchLucene),
            search_lucene_order: option.bddCtrl.utiCourantParaJson[option.context_grid].order_search,
            lst_id_table_lucene: option.lstIdTableIdLucene,
            lst_idtable_id_exclu: tabIdTableIdExclu,
            lst_idtable_id_inclu: tabIdTableIdInclu,
            id_dossier: option.idDossier,
            is_for_doublon: ((option.isForDoublon) ? "1" : "0")
        }

        if (option.typeData == "strcon") {
            var lstDataFiltre = []
            if (option.dataGridVue) {
                if (option.dataGridVue.filter_json2 == null || option.dataGridVue.filter_json2.length == 0) {
                    option.dataGridVue.filter_json2 = '{ "montrer_str": 1, "montrer_strcon": 1, "montrer_con": 1, "montrer_cptcli": 1, "montrer_cptcliuti": 1, "datafiltre": null }'
                    option.bddCtrl.getObjet(option.dataGridVue).mSave()
                }
                dataToBeSent.data_filter_gridvue = JSON.parse(option.dataGridVue.filter_json2)
                if (dataToBeSent.data_filter_gridvue.datafiltre) {
                    lstDataFiltre.push(dataToBeSent.data_filter_gridvue.datafiltre)
                }
            }

            if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon) {
                dataToBeSent.data_filtrestrcon = option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtregridstrcon
                if (dataToBeSent.data_filtrestrcon.datafiltre) {
                    lstDataFiltre.push(dataToBeSent.data_filtrestrcon.datafiltre)
                }
            }

            if (option.conditionsBase) lstDataFiltre.push({ type_filtre: "avance", json_lst_condition: JSON.stringify(option.conditionsBase) })

            if (option.conditionsCache) lstDataFiltre.push({ type_filtre: "avance", json_lst_condition: JSON.stringify(option.conditionsCache) })

            var filterClass = new cFilterGeneral(option.bddCtrl, "strcon")
            dataToBeSent.sql = filterClass.mGetSqlFromLstDataFiltres(lstDataFiltre).sql
            dataToBeSent.sql_str_for_strcon = filterClass.mGetSqlFromLstDataFiltres(lstDataFiltre).sqlStrForStrCon

        } else if (option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase != null) {
            var filterClass = new cFilterGeneral(option.bddCtrl, option.typeData)
            dataToBeSent.sql = filterClass.mGetSqlFromLstDataFiltres([option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase]).sql
            if (dataToBeSent.sql.length == 0 || dataToBeSent.sql == "()") dataToBeSent.sql = "(1=1)"
            dataToBeSent.sql_str_for_strcon = filterClass.mGetSqlFromLstDataFiltres([option.bddCtrl.utiCourantParaJson[option.context_grid].data_filtrebase]).sqlStrForStrCon
            if (dataToBeSent.sql_str_for_strcon.length == 0 || dataToBeSent.sql_str_for_strcon == "()") dataToBeSent.sql_str_for_strcon = "(1=1)"
        }

        if (option.bddCtrl.utiCourantParaJson[option.context_grid].typeGrille == "carto") {
            dataToBeSent.lst_champ_select = option.lstChampSelectSiCarto
        }
        console.log("demande DATA")
        reqGetData = option.bddCtrl.mAjaxCall(dataToBeSent, function (data) {
            if (getCount) {
                funcOk(data.count)
            } else {
                console.log("fin demande DATA")
                if (option.typeData == "fichier") {
                    if (typeof data.lstdata == 'undefined') data.lstdata = []
                    //convertDatesObjetJson(data.lstdata)
                } else {
                    if (typeof data.lstdata == 'undefined') data.lstdata = "[]"
                    if (typeof data.lstdata === "string") data.lstdata = JSON.parse(data.lstdata)
                    data.lstdata = convertDatesObjetJson(data.lstdata)
                    var dat = new Date()
                    data.lstdata = mMapLstDataGrid(data.lstdata)
                    console.log("temps calcul: " + (dat - (new Date())))
                }
                funcOk(data.lstdata)
                if (typeof option.onEndLoadData != 'undefined') option.onEndLoadData()
                if (typeof option.onEndGetData != 'undefined') option.onEndGetData(data.lstdata)
            }
        }, function () { reqGetData = null; }, function (data) {
            //error
            $("body").find(".dx-ctrljauge").each(function () {
                var jauge = $(this).getInstance()
                jauge.mHide();
            })
            //mNotify("Une erreur est survenue sur le serveur. Impossible de faire le traitement demandé.", "warning", 6000)
            if (!getCount) {
                mNotify("Impossible de charger la grille. Peut-être avez vous un filtre compliqué qui dépasse les capacités de votre base de données. <a>Vérifiez le filtre de la grille</a>.", "warning", 6000, function () {
                    if (dxBtFiltre) dxBtFiltre.performClick()
                })
            }
            if (option.typeData == "strcon" && dxFilter && dxFilter.typeFiltreCourant == "ia") {
                try {
                    var question = dxFilter.dxFilterCourant.mGetText()
                    var data = JSON.stringify(dxFilter.dxFilterCourant.option("data").ia_json_result)
                    option.bddCtrl.mAjaxCall({ command: "enregistreerreuria", question: question, json: data })
                } catch (e) {

                }

            }
        })
    }

    var $DivIa = null
    var dxCtrlIa = null
    var lstQuestionIa = []
    function mShowIa() {
        if ($DivIa == null) {
            $DivIa = $("<div style='position:absolute;top:0;left:0;height:100%;width:100%;z-index:5;display:none;' class='dx-theme-material-typography'/>").appendTo(container)
            var $DivIaInner = $("<div style='position:relative;height:100%;width:100%;'/>").appendTo($DivIa)

            dxBtClose = $("<div style='position:absolute;z-index:10;top:2px;right:5px'/>").appendTo($DivIaInner).dxCtrlButton({
                icon: 'fas fa-times',
                width: HeightButton,
                height: HeightButton,
                onClick: function (e) { $DivIa.slideUp(500) }
            }).dxCtrlButton("instance");

            dxCtrlIa = $("<div style='padding:20px;position:absolute;top:0;left:0;height:100%;width:100%;z-index:1;'/>").appendTo($DivIaInner).dxCtrlIa({
                bddCtrl: option.bddCtrl,
                htmlIntro: option.htmlIntroIa,
                showHisto: false,
                funcQuestion: function (question, idIaConversation, funcOk) {
                    lstQuestionIa.push({ q: question })
                    var optIa = {
                        command: "questioniaforgrid",
                        type_data: option.typeData,
                        lst_question: lstQuestionIa
                    }
                    option.onDefineOptionIa(optIa)
                    return option.bddCtrl.mAjaxCall(optIa,
                        function (data) {
                            if (typeof data.date_mois != 'undefined' || typeof data.date_jour != 'undefined') {
                                if (typeof data.date_mois != 'undefined') {
                                    data.date_mois = data.date_mois.addMonths(1)
                                    data.reponse = { html: "<div style='color:orange;'>Vous avez dépassé votre quota mensuel de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_mois.toFrenchDateTime() + "</div>" }
                                } else {
                                    data.date_jour = data.date_jour.addDays(1)
                                    data.reponse = { html: "<div style='color:orange;'>Vous avez dépassé votre quota journalier de requètes pou MIA. Vous pourrez à nouveau faire des requètes à partir du " + data.date_jour.toFrenchDateTime() + "</div>" }
                                }
                            }
                            funcOk(data)
                        })
                }
            }).dxCtrlIa("instance")

            dxCtrlIa.mGetDxQuestion().option("value", "fait moi un résumé de la fiche et dis moi si nos échanges sont positif.")
            dxCtrlIa.dxBtGo.performClick()
        }
        $DivIa.slideDown(500, function () { dxCtrlIa.mGetDxQuestion().focus() })
    }

    this.mRefresh = function () {
        dxGrid.mRefresh()
    }

    this.component = function () { return dx; }
    this.element = function () { return container; }

    mConstruit();
}